export default __webpack_public_path__ + "static/media/Maikol-SanchezCv.552d9a62.pdf";